import React from "react";
import "./HowItWorks.css";
import { FiGrid } from "react-icons/fi";
import { FiCheckSquare } from "react-icons/fi";
import { FiUser } from "react-icons/fi";
import { FiRefreshCw } from "react-icons/fi";

const iconMap = { grid: FiGrid, check: FiCheckSquare, user: FiUser, refresh: FiRefreshCw };
const defaultSteps = [
  { icon: FiGrid, title: "Select a Style", description: "Pick your perfect style from our collection of designer outfits and accessories." },
  { icon: FiCheckSquare, title: "Book your Outfit", description: "Book your look for 3, 5, 7 or 10 days. Outfit will be altered to your size and dry cleaned before delivery." },
  { icon: FiUser, title: "Flaunt It", description: "Flaunt your look with that perfect outfit chosen by you and enjoy the compliments." },
  { icon: FiRefreshCw, title: "Return It", description: "Pack the outfit and we'll pick it up a day after your occasion or the dates chosen by you." },
];

const HowItWorks = (props) => {
  const blockProps = props?.props || {};
  const stepsFromApi = blockProps.steps;
  const useDefaults = !stepsFromApi?.length || stepsFromApi.length === 3;
  const steps = useDefaults
    ? defaultSteps
    : stepsFromApi.map((s) => ({ ...s, icon: iconMap[s.icon] || FiGrid }));
  return (
    <section className="howItWorks">
      <p className="howItWorksEyebrow">The process</p>
      <h2 className="howItWorksTitle">
        {blockProps.title || <>How <span className="howItWorksAccent">Gem Fashion</span> Works</>}
      </h2>
      <div className="howItWorksGrid">
        {steps.map((step, index) => {
          const Icon = step.icon || defaultSteps[index]?.icon || FiGrid;
          return (
            <div key={index} className="howItWorksStep">
              <div className="howItWorksIconWrap">
                <Icon className="howItWorksIcon" aria-hidden="true" />
              </div>
              <h3 className="howItWorksStepTitle">{step.title}</h3>
              <p className="howItWorksStepDesc">{step.description}</p>
              <div className="howItWorksNumber">{index + 1}</div>
            </div>
          );
        })}
      </div>
      <div className="howItWorksLine" aria-hidden="true" />
    </section>
  );
};

export default HowItWorks;
